import { type ReactNode, useState } from "react";

export interface FilterGroup {
  label: string;
  options: string[];
  value: string;
  onChange: (value: string) => void;
}

interface FilterBarProps {
  groups: FilterGroup[];
  className?: string;
  extra?: ReactNode;
}

export default function FilterBar({ groups, className = "", extra }: FilterBarProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={`rounded-lg border border-background-200 bg-background-50 ${className}`}>
      <div className="flex items-center justify-between gap-3 border-b border-background-200 px-4 py-3 lg:hidden">
        <span className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
          <i className="ri-filter-3-line text-base text-primary-500" />
          筛选条件
        </span>
        <button
          type="button"
          onClick={() => setExpanded((prev) => !prev)}
          className="flex items-center gap-0.5 whitespace-nowrap rounded-md border border-background-200 px-3 py-1.5 text-xs font-medium text-foreground-600"
        >
          {expanded ? "收起" : "展开"}
          <i className={`text-base transition-transform ${expanded ? "rotate-180" : ""}`} />
        </button>
      </div>

      <div className={`${expanded ? "block" : "hidden"} lg:block`}>
        <div className="flex flex-col divide-y divide-background-200">
          {groups.map((group) => (
            <div key={group.label} className="flex flex-col gap-2.5 px-4 py-3.5 sm:flex-row sm:items-center sm:gap-4">
              <span className="w-16 shrink-0 text-sm font-medium text-foreground-500">{group.label}</span>
              <div className="flex flex-wrap gap-2">
                {group.options.map((option) => {
                  const active = option === group.value;
                  return (
                    <button
                      key={option}
                      type="button"
                      onClick={() => group.onChange(option)}
                      className={`whitespace-nowrap rounded-full px-3.5 py-1 text-sm transition-colors ${
                        active
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-100 text-foreground-600 hover:bg-primary-50 hover:text-primary-600"
                      }`}
                    >
                      {option}
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>

      {extra && <div className="border-t border-background-200 px-4 py-3">{extra}</div>}
    </div>
  );
}